import { render, staticRenderFns } from "./LineItemTable.vue?vue&type=template&id=2ab161c4&scoped=true"
import script from "./LineItemTable.vue?vue&type=script&lang=js"
export * from "./LineItemTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab161c4",
  null
  
)

export default component.exports